import React from 'react';
import { useTranslation } from 'react-i18next';
import ExternalArchiveSection from '../components/ExternalArchiveSection';
import './Me.css';
import '../styles/common.css';

function Me() {
  const { t } = useTranslation();

  const experience = t('me.experience', { returnObjects: true });
  const _unused_exp = [
    {
      period: '2022 ~ 2023',
      title: '디지털 트윈 기반 시각화 시스템 개발',
      desc: '디지털 트윈의 “보이는 시스템”을 만들며, 사용자 인터랙션과 구조적 표현에 집중했습니다.',
      tags: ['3D', 'Unreal', 'C++', 'Interaction'],
    },
    {
      period: '2024 ~ 2025',
      title: '에너지·설비 운영 모니터링 시스템 개발',
      desc: '운영 데이터를 다루는 시스템을 만들며, 설계·배치·대시보드·협업의 현실 조건 속에서 안정적인 흐름을 구축했습니다.',
      tags: ['Vue', 'Spring Boot', 'JPA', 'Batch'],
    },
    {
      period: '2026 ~',
      title: 'AI Agents · AI Workforce TF (경영기획실 파견)',
      desc: 'AI Agent 워크플로우·운영 파이프라인을 설계하는 한편, 2026년 4월부터 경영기획실 AI Workforce TF로 파견되어 그룹사 AI 에이전트 구축 지원, 현업 요구를 반영한 구조 설계·구현, LLM 기반 아키텍처·툴 연계·시나리오 정리, PoC·실서비스 적용 검토 등을 수행하고 있습니다.',
      tags: ['AI Agents', 'LLM', 'Python', 'Automation'],
      highlight: true,
    },
  ];

  const certs = [
    'AWS CCP (2025.01 만료)',
    '정보처리기사',
    'SQLD',
    '컴퓨터 활용 능력 1급',
    'JLPT N1',
    'OPIc IM2',
    'JPT',
    'Dataiku',
  ];

  const stack = [
    'LangChain',
    'LangGraph',
    'MCP',
    'FastAPI',
    'Python',
    'React',
    'Vue.js',
    'Spring Boot',
    'PostgreSQL',
    'TensorFlow',
  ];

  const keywords = t('me.keywords', { returnObjects: true });

  const tlLegendLabels = t('me.tlLegend', { returnObjects: true });
  const timelineLegend = [
    { label: Array.isArray(tlLegendLabels) ? tlLegendLabels[0] : '학력/교육', dotClass: 'dot-edu' },
    { label: Array.isArray(tlLegendLabels) ? tlLegendLabels[1] : '활동/경험', dotClass: 'dot-act' },
    { label: Array.isArray(tlLegendLabels) ? tlLegendLabels[2] : '자격증/수료', dotClass: 'dot-cert' },
    { label: Array.isArray(tlLegendLabels) ? tlLegendLabels[3] : '경력', dotClass: 'dot-work' },
    { label: Array.isArray(tlLegendLabels) ? tlLegendLabels[4] : '수상', dotClass: 'dot-award' },
  ];

  const timeline = t('me.timeline', { returnObjects: true }) || [];


  return (
    <main className="me" aria-label="Journey 상세">
      {/* HERO */}
      <section className="me-hero">
        <div className="me-container">
          <div className="me-hero-grid">
            <div className="me-hero-left">
              <p className="me-kicker">{t('me.kicker')}</p>
              <h1 className="me-title">{t('me.title')}</h1>

              <p className="me-lead">{t('me.lead1')}</p>
              <p className="me-lead me-lead--sm" dangerouslySetInnerHTML={{ __html: t('me.lead2') }} />

              <div className="me-quote" role="note" aria-label="가치관">
                <span className="me-quote-mark" aria-hidden="true">
                  “
                </span>
                <p className="me-quote-text">
                  Think Global, Act Global, Love Local
                  <br />
                  {t('me.quote')}
                </p>
              </div>

              <div className="me-chip-row" aria-label="키워드">
                {(t('me.chips', { returnObjects: true })).map((c, i) => <span key={i} className="chip">{c}</span>)}
              </div>
            </div>

            <aside className="me-hero-right" aria-label="기본 정보">
              <div className="me-info-card">
                <div className="me-profile-card">
                  <img src="/k.png" alt="Ahhyun Kim" className="me-profile-avatar" />
                  <div className="me-profile-info">
                    <strong className="me-profile-name">Ahhyun Kim</strong>
                    <span className="me-profile-title">AI Engineer · POSCO DX</span>
                    <a
                      href="https://kr.linkedin.com/in/ahhyun-kim-a58284376"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="me-profile-linkedin"
                    >
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                      LinkedIn ↗
                    </a>
                  </div>
                </div>
                <div className="me-info-row">
                  <div className="me-info-label">Email</div>
                  <div className="me-info-value">calicorone@gmail.com</div>
                </div>

                <div className="me-info-row">
                  <div className="me-info-label">{t('me.infoOrg')}</div>
                  <div className="me-info-value">
                    {t('me.infoOrgVal')}
                    <br />
                    <span className="me-info-note">{t('me.infoOrgNote')}</span>
                  </div>
                </div>

                <div className="me-info-row">
                  <div className="me-info-label">{t('me.infoRank')}</div>
                  <div className="me-info-value">CL2</div>
                </div>

                <div className="me-divider" />

                <div className="me-info-row">
                  <div className="me-info-label">Focus</div>
                  <div className="me-info-value">Engineering · Modeling · Automation · Agents</div>
                </div>

              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* EXPERIENCE */}
      <section className="me-section">
        <div className="me-container">
          <div className="section-header-area">
            <h2 className="section-title">{t('me.expTitle')}</h2>
            <p className="section-disclaimer">
{t('me.expDisclaimer')}
            </p>
          </div>
          <p className="me-desc">
{t('me.expLead1')}
          </p>
          <p className="me-desc">
{t('me.expLead2')}
          </p>

          <div className="me-exp-grid">
            {experience.map((x) => (
              <article
                key={x.period}
                className={`me-exp-card ${x.highlight ? 'is-highlight' : ''}`}
              >
                <div className="me-exp-top">
                  <span className="me-exp-period">{x.period}</span>
                  {x.highlight && <span className="me-exp-now">Now</span>}
                </div>

                <h3 className="me-exp-title">{x.title}</h3>
                <p className="me-exp-text">{x.desc}</p>

                <div className="me-exp-tags" aria-label="기술 태그">
                  {x.tags.map((t) => (
                    <span key={t} className="chip">
                      {t}
                    </span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* SNAPSHOT */}
      <section className="me-section">
        <div className="me-container">
          <div className="section-header-area">
            <h2 className="section-title">{t('me.snapshotTitle')}</h2>
          </div>
          <p className="me-desc">{t('me.snapshotDesc')}</p>

          <div className="me-snap-grid">
            <section className="me-card" aria-label="자격증 및 교육">
              <h3 className="me-card-title">{t('me.certsTitle')}</h3>
              <div className="me-chip-row">
                {certs.map((c) => (
                  <span className="chip" key={c}>
                    {c}
                  </span>
                ))}
              </div>
              <p className="me-note">• 비트컴퓨터 채용예정자 교육 수료</p>
            </section>

            <section className="me-card" aria-label="기술 스택">
              <h3 className="me-card-title">{t('me.stackTitle')}</h3>
              <div className="me-chip-row">
                {stack.map((s) => (
                  <span className="chip" key={s}>
                    {s}
                  </span>
                ))}
              </div>
            </section>

            <section className="me-card" aria-label="업무 키워드">
              <h3 className="me-card-title">{t('me.keywordsTitle')}</h3>
              <ul className="me-list">
                {keywords.map((k) => (
                  <li key={k}>{k}</li>
                ))}
              </ul>
            </section>
          </div>
        </div>
      </section>

      <section className="me-section">
        <div className="me-container">
          <div className="section-header-area">
            <h2 className="section-title">{t('me.timelineTitle')}</h2>
          </div>
          <p className="me-desc">{t('me.timelineDesc')}</p>

          <div className="me-timeline">
            <div className="me-timeline-legend">
              {timelineLegend.map((x) => (
                <span className="me-timeline-legend-item" key={x.label}>
                  <span className={`me-timeline-dot ${x.dotClass}`} />
                  {x.label}
                </span>
              ))}
            </div>

            <div className="me-timeline-track">
              {timeline.map((yearBlock) => (
                <section className="me-year-block" key={yearBlock.year}>
                  {yearBlock.items.map((item, itemIndex) => (
                    <article
                      className="me-timeline-row"
                      key={`${yearBlock.year}-${item.title}`}
                    >
                      <div className="me-timeline-year-cell">
                        {itemIndex === 0 && (
                          <span className="me-year-label">{yearBlock.year}</span>
                        )}
                      </div>
                      <div className="me-timeline-axis-cell">
                        <span
                          className={`me-timeline-dot dot-${item.type}`}
                          aria-hidden="true"
                        />
                      </div>
                      <div className="me-timeline-item-body">
                        <h3 className="me-timeline-item-title">{item.title}</h3>
                        <p className="me-timeline-item-sub">{item.sub}</p>
                        {item.details?.length > 0 && (
                          <>
                            {item.detailsTitle && (
                              <p className="me-timeline-details-title">{item.detailsTitle}</p>
                            )}
                            <ul className="me-timeline-details">
                              {item.details.map((line) => (
                                <li key={line}>{line}</li>
                              ))}
                            </ul>
                          </>
                        )}
                        {item.link?.url && (
                          <a
                            href={item.link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="me-timeline-item-link"
                          >
                            {item.link.label ?? item.link.url}
                          </a>
                        )}
                        {item.tags?.length > 0 && (
                          <div className="me-timeline-tags">
                            {item.tags.map((tag) => (
                              <span className="me-timeline-tag" key={tag}>
                                {tag}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </article>
                  ))}
                </section>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 📚 ARCHIVE TABS (External Logs) */}
      <section className="me-section archive-section">
        <div className="me-container">
          <ExternalArchiveSection
            showTitle
            title="Archives"
            disclaimer={t('me.archiveDisclaimer')}
          />
        </div>
      </section>
    </main>
  );
}

export default Me;
